import { cn } from '@/lib/utils'

/* Markdown `#` renders an h2, not an h1. Both surfaces that mount this map —
   the blog article and the doc page — already print the entry's title as the
   page h1 above the body, and every authored blog post opens with a `#` that
   repeats it, so an h1 here gave those routes two (docs: three) top-level
   headings. The key stays `h1` because that is the MDX element it maps. */
export const h1 = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={cn(
      'font-heading mt-2 scroll-m-20 text-4xl font-normal',
      className
    )}
    {...props}
  />
)
